(function AdditionalComponents($, Adzuki)
{
	"use strict";

	var form = {
		name: 'GroupRegistrationAdditionalComponents',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
		if ($('form[name=GroupRegistrationAdditionalComponents]').length > 0) {
			init();
		}
	});

	function init()
	{
		$('.change-component').on('change', handleAddComponent);
		$('.component-category').on('change', updateRegistrationPricing);
		$('#groupregistrationadditionalcomponents-groupregistration-insurance').on('change', toggleInsuranceWaiver);

		// Show the category options for any components that are already selected on page load
		$('.add-component').each(function findComponents(index, el) {
			var component_id = parseInt($(el).val());

			// If component selected
			if (($(el).is(':checked') || $(el).is('input[type=hidden]')) && component_id > 0) {
				$('#component-categories-' + component_id).removeClass('hidden');
			}
		});

		updateRegistrationPricing();
		toggleInsuranceWaiver();
	}

	function handleAddComponent()
	{
		var component_id = $(this).data('component-id');
		var value        = parseInt($(this).val());

		if (value > 0 && ($(this).is(':checked') || $(this).is('input[type=hidden]'))) {
			$('#component-categories-' + component_id).removeClass('hidden');
		} else if (value === 0) {
			$('#component-categories-' + component_id).addClass('hidden');
		}

		updateRegistrationPricing();
	}

	function updateRegistrationPricing()
	{
		var components_to_price = [];

		// If the pricing container div isn't present - nothing to update
		// This happens with single_payment_source = 1. registrants don't see pricing
		if ($('#registration-pricing-container').length === 0) {
			return;
		}

		// Loop through all components
		$('.change-component').each(function findComponents(index, el) {
			var component_id = parseInt($(el).val());

			// If component selected
			if (($(el).is(':checked') || $(el).is('input[type=hidden]')) && component_id > 0) {
				// get selected category and occupancy
				$(".component-category[data-component-id='" + component_id + "']").each(function findCategory(i, el) {
					var category_occupancy;
					if ($(el).is(':checked')) {
						category_occupancy = $(el).val().split('_');
						components_to_price.push({
							component_id: component_id,
							category_id : category_occupancy[0],
							occupancy_id: category_occupancy[1]
						});
					}
				});
			}
		});

		Adzuki.Ajax.post('/GroupRegistrations/priceWithAdditionalComponents', {
			components_to_price: components_to_price
		}).then(function success(response) {
			$('#registration-pricing-container').html(response);
		});
	}

	function toggleInsuranceWaiver()
	{
		if ($('#groupregistrationadditionalcomponents-groupregistration-insurance').is(':checked')) {
			$('#insurance-waiver-container').addClass('hidden');
			$('#groupregistrationadditionalcomponents-groupregistration-decline_insurance').prop('checked', false);
			$('#groupregistrationadditionalcomponents-groupregistration-decline_insurance_signature').val('');
		} else {
			$('#insurance-waiver-container').removeClass('hidden');
		}
	}

}(jQuery, window.Adzuki || {}));